var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-page',{attrs:{"padding":""}},[_c('form-events-incident',{attrs:{"type-incident":_vm.$options.EVENTS_MAIN_TYPE_SPECIFIC_CONTROL},model:{value:(_vm.controle),callback:function ($$v) {_vm.controle=$$v},expression:"controle"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }